import apiClient from "./axios"

// ✅ Get Car Care customer payments (with filters / pagination)
export const getCarCareCustomerPayments = async (params = {}) => {
  const { data } = await apiClient.get("/car-care-customer-payments", {
    params,
  })
  return data
}

// ✅ Record a Car Care customer payment (service invoice payment)
export const createCarCareCustomerPayment = async payload => {
  const { data } = await apiClient.post(
    "/car-care-customer-payments",
    payload
  )
  return data
}

// ✅ Delete a Car Care customer payment (reverses its ledger entry)
export const deleteCarCareCustomerPayment = async id => {
  const { data } = await apiClient.delete(
    `/car-care-customer-payments/${id}`
  )
  return data
}
